import Loadable from '@townsquare/loadable';

export const GoalsApp = Loadable({
  loader: () => import(/* webpackChunkName: "goals-app-entry" */ '@townsquare/goals/app'),
  loading: () => null,
});
